"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subtractTotalSeats = exports.calcTotalSeats = exports.calcAllotmentsTotalSeats = void 0;
const calcAllotmentsTotalSeats = (tariffGroups, allotments) => {
    if (!(allotments === null || allotments === void 0 ? void 0 : allotments.length))
        return undefined;
    const result = tariffGroups.map((tariff) => {
        var _a;
        const getSeatsNumber = (allotment) => {
            var _a;
            return (((_a = allotment.tariffGroup) === null || _a === void 0 ? void 0 : _a.id) === tariff.id
                ? allotment.seatsNumber
                : undefined);
        };
        const count = (_a = allotments === null || allotments === void 0 ? void 0 : allotments.reduce((acc, x) => { var _a; return acc + ((_a = getSeatsNumber(x)) !== null && _a !== void 0 ? _a : 0); }, 0)) !== null && _a !== void 0 ? _a : 0;
        return {
            count,
            tariff,
        };
    });
    return result;
};
exports.calcAllotmentsTotalSeats = calcAllotmentsTotalSeats;
const calcTotalSeats = (tariffGroups, seats, allowed) => {
    if (!allowed)
        return undefined;
    const result = tariffGroups.map((tariff) => {
        var _a, _b;
        const count = (_b = (_a = seats === null || seats === void 0 ? void 0 : seats.find(x => { var _a; return ((_a = x.tariffGroup) === null || _a === void 0 ? void 0 : _a.id) === tariff.id; })) === null || _a === void 0 ? void 0 : _a.totalSeats) !== null && _b !== void 0 ? _b : 0;
        return {
            count,
            tariff,
        };
    });
    return result;
};
exports.calcTotalSeats = calcTotalSeats;
const subtractTotalSeats = (first, second) => {
    if (!first || !second)
        return undefined;
    const result = first.map(x => {
        var _a, _b;
        const secondCount = (_b = (_a = second.find(y => y.tariff.id === x.tariff.id)) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0;
        return {
            count: x.count - secondCount,
            tariff: x.tariff,
        };
    });
    return result;
};
exports.subtractTotalSeats = subtractTotalSeats;
//# sourceMappingURL=utils.js.map